import { FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { getLimitNumText } from 'components/ActivityListCardItem/module/getLimitNumText'

interface IFRightItemProps {
  label: string
  filterCount?: number
  onClick: () => void
  endAdornment?: ReactNode
  isActive?: boolean
  className?: string
}

const RightItem: FC<IFRightItemProps> = ({
  label,
  filterCount,
  onClick,
  endAdornment,
  isActive = false,
  className,
}) => {
  return (
    <StyledWrapper
      data-is-active={isActive}
      className={className}
      onClick={onClick}
    >
      <div>
        {label}
        {filterCount !== undefined && (
          <span className="filter-count">
            ({getLimitNumText({ number: filterCount, limit: 999 })})
          </span>
        )}
      </div>
      {endAdornment}
    </StyledWrapper>
  )
}

export default RightItem

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    display: inline-flex;
    justify-content: space-between;
    width: 100%;
    padding: 11px 15px;
    font-size: 13px;
    font-weight: normal;
    color: ${theme.color.text_1};
    cursor: pointer;

    .filter-count {
      color: ${theme.color.text_2};
      margin-left: 2px;
    }
  `}
`
